import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformContextErrorCode {
  IncorrectEnvironment = 'IncorrectEnvironment',
}

class EditorPlatformContextError extends BaseError<EditorPlatformContextErrorCode> {
  state: Partial<{
    url: string;
    appDefinitionId: string;
  }> = {};

  constructor(message: string, code: EditorPlatformContextErrorCode) {
    super(message, code, 'EP Context Error');
  }

  withUrl(url: string) {
    this.state = { ...this.state, url };
    return this;
  }

  withAppDefinitionId(appDefinitionId: string) {
    this.state = { ...this.state, appDefinitionId };
    return this;
  }
}

export const createEditorPlatformContextError = createErrorBuilder<
  EditorPlatformContextErrorCode,
  EditorPlatformContextError
>(EditorPlatformContextError);
